<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"><span class="lineh">seasonal</span></a></h1><a id="page_iii">
<h1 class="title"><span class="lineh1">plant</span></h1>
<h1 class="title">dyes</h1>
<p class="titleSub">Create your own beautiful botanical dyes,<br/>plus four seasonal projects to make</p>
<p class="author"><span class="bold">ALICIA HALL</span></p>
<p class="author2"><em class="italic">Photographs by Alicia Hall</em></p>
<div class="pub"><img alt="Images" src="images/pub.jpg"/></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?d8c4f892